import moment from 'moment';
import ContractType from '../../../model/enum/ContractType';
import { IContractRates } from '../../../model/HiringContract/IContractRates';
import { IArrayOption } from '../../../model/IArrayOption';
import { ExpenseDetail, FlightExpenses } from '../../../model/IFlightExpense';
import { FlightReport } from '../../../model/IFlightReport';
import { IPaginationResult } from '../../../model/search/IPaginationResult';
import { ExpenseDetailCRUD } from '../../../operations/ExpenseDetailCRUD';
import { AuthContextProps } from 'react-oidc-context';
import { getContractRates } from '../../../services/ContractRateService';
import { RateUnitService } from '../../../services/domainServices/RateUnitService';
import { IRateUnit } from '../../../model/domainServices/IRateUnit';

const createAdditionalExpenseLongTerm = async (
  expenseType: string,
  numberOfItems: number,
  objFlightReport: FlightReport,
  expenseContractRatesPaginationResult: IPaginationResult<IContractRates>,
  rateTypeOptions: IArrayOption[],
  rateUnitOptions: IArrayOption[],
  auth: AuthContextProps,
  fireNumberOptions: IArrayOption[],
  costingActivityOptions: IArrayOption[],
  internalOrderOptions: IArrayOption[],
  costCenterOptions: IArrayOption[],
  fundOptions: IArrayOption[],
  accountOptions: IArrayOption[],
): Promise<ExpenseDetail> => {
  const expense = new ExpenseDetail();
  var rateType, contractRates;

  rateType = rateTypeOptions.find((t) => t.label === expenseType);

  if (rateType) {
    expense.rateTypeId = rateType.value;
    expense.rateType = expenseType;
  }

  // if (expenseContractRatesPaginationResult) {
  //     contractRates = getContractRates(
  //         expenseContractRatesPaginationResult,
  //         rateType?.oracleId ?? 0,
  //     );
  // }

  // expense.noOfUnits = numberOfItems;

  // if (contractRates) {
  //     rateUnit = await RateUnitService.getByOracleId(
  //         contractRates?.cruId ?? 0,
  //     );
  // }

  //   expense.rateUnitId = rateUnit ? rateUnit?.data?.rateUnitId : undefined;
  //   expense.ratePerUnit = contractRates?.ratePerUnit ?? 0;
  expense.flightReportId = objFlightReport.flightReportId;
  expense.cost = expense.noOfUnits * expense.ratePerUnit;
  expense.createTimestamp = moment(new Date()).format('yyyy-MM-DD');
  expense.createUserId = auth?.user?.profile?.name ?? 'wildfire';
  expense.deleted = false;

  //Drop down list bind
  expense.fireNumberList = fireNumberOptions ?? undefined;
  expense.costingActivityList = costingActivityOptions ?? undefined;
  expense.rateTypeList = rateTypeOptions ?? undefined;
  expense.rateUnitList = rateUnitOptions ?? undefined;

  //1GX coding - financial
  expense.internalOrderList = internalOrderOptions ?? undefined;
  expense.costCenterList = costCenterOptions ?? undefined;
  expense.fundList = fundOptions ?? undefined;
  expense.accountList = accountOptions ?? undefined;

  //Default costing activity
  if (costingActivityOptions) {
    if (costingActivityOptions.find((x) => x.code === 'FP0220')) {
      var objCostingActivity = costingActivityOptions.find((x) => x.code === 'FP0220');
      if (objCostingActivity) expense.costingActivityCode = objCostingActivity?.code ?? '';
      expense.costingActivityId = objCostingActivity?.value;
    }
  }

  //Default cost-center for basing & basing non-core

  if (expenseType.toLowerCase() === 'basing' || expenseType.toLowerCase() === 'basing non-core') {
    if (
      objFlightReport.aircraftWingType.toLowerCase() === 'rotary' &&
      objFlightReport.aircraftSize.toLowerCase() !== 'air tanker' &&
      costCenterOptions
    ) {
      expense.costCenter = '621790';
    } else if (
      objFlightReport.aircraftWingType.toLowerCase() === 'fixed' &&
      objFlightReport.aircraftSize.toLowerCase() === 'air tanker' &&
      costCenterOptions
    ) {
      expense.costCenter = '621597';
    }
  }
  let rateUnitId: string = '';
  let ratePerUnit: number = 0;
  let rateUnit: IRateUnit;
  //   if (!objFlightReport.hiringDetailsId) {
  if (expenseContractRatesPaginationResult) {
    contractRates = getContractRates(expenseContractRatesPaginationResult, rateType?.oracleId ?? 0);
  }

  if (contractRates) {
    const result = await RateUnitService.getByOracleId(contractRates?.cruId ?? 0);
    rateUnit = result.data;
    rateUnitId = rateUnit?.rateUnitId ?? '';
    ratePerUnit = contractRates?.ratePerUnit ?? 0;
  }

  expense.noOfUnits = numberOfItems;
  expense.rateUnitId = rateUnitId;
  expense.ratePerUnit = ratePerUnit;
  expense.cost = expense.noOfUnits * expense.ratePerUnit;
  //Default Fund
  if (fundOptions) {
    if (fundOptions.find((x) => x.value === '41')) expense.fund = '41';
  }

  //Default Account
  if (accountOptions) {
    if (accountOptions.find((x) => x.value === '6020700210')) expense.account = '6020700210';
  }

  return expense;
};

export const onFlightReportSaveCreateBasingExpenseLongTerm = async (
  objFlightReport: FlightReport,
  expenseContractRatesPaginationResult: IPaginationResult<IContractRates>,
  rateTypeOptions: IArrayOption[],
  rateUnitOptions: IArrayOption[],
  fireNumberOptions: IArrayOption[],
  costingActivityOptions: IArrayOption[],
  internalOrderOptions: IArrayOption[],
  costCenterOptions: IArrayOption[],
  fundOptions: IArrayOption[],
  accountOptions: IArrayOption[],
  auth: AuthContextProps,
) => {
  var objFlightExpenses = new FlightExpenses();
  var response = false;

  if (objFlightReport) {
    var expenseRateType;

    if (objFlightReport?.contractRegistration?.contractType === ContractType.long) {
      //Basing
      if (expenseContractRatesPaginationResult?.data.find((value) => value.crtyId === 4)) {
        expenseRateType = 'Basing';
      }
      //Basing Non-Core
      else {
        expenseRateType = 'Basing Non-Core';
      }

      const expense = await createAdditionalExpenseLongTerm(
        expenseRateType,
        1,
        objFlightReport,
        expenseContractRatesPaginationResult,
        rateTypeOptions,
        rateUnitOptions,
        auth,
        fireNumberOptions,
        costingActivityOptions,
        internalOrderOptions,
        costCenterOptions,
        fundOptions,
        accountOptions,
      );

      if (expense) {
        objFlightExpenses.contractType = objFlightReport?.contractRegistration?.contractType;
        objFlightExpenses.expenseDetails[0] = expense;
        objFlightExpenses.flightCrewEligibility = [];
        objFlightExpenses.flightOtherExpenses.createTimestamp = moment(new Date()).format('yyyy-MM-DD');
        objFlightExpenses.flightOtherExpenses.createUserId = auth?.user?.profile?.name ?? 'wildfire';
      }

      if (objFlightExpenses.expenseDetails.length > 0) {
        var objResponse = await ExpenseDetailCRUD.createAndUpdate(
          objFlightExpenses,
          objFlightReport?.flightReportId,
          auth.user?.access_token as string,
        );
        if (objResponse.status) {
          response = true;
        }
      }
    }
  }

  return response;
};
